import { Component, OnInit } from '@angular/core';
import { concatMap } from 'rxjs/operators';
import { AuthService } from 'src/app/core/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { LoginModel } from 'src/app/core/models/login.model';
import { LoginResultModel } from 'src/app/core/models/login-result.model';
import { RouteStateService } from 'src/app/core/services/route-state.service';
import { ResetPasswordService } from 'src/app/core/services/reset-password.service';
import { CommonFunctionsService } from 'src/app/core/services/common-functions.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  isLoading: boolean = false;
  token: string = null;
  tokenIsValid: boolean = null;
  email: string = null;
  password: string = null;

  constructor(
    private resetPasswordService: ResetPasswordService,
    private commonFunctionsService: CommonFunctionsService,
    private routeStateService: RouteStateService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
  ) {  
    
    this.route.queryParams.subscribe(params => {
      this.token = params['token'];

    });    
  }

  ngOnInit(): void {
    if(this.token){
      this.getTokenInfo();
    }
    else{
      this.router.navigate(['/login']);
    }
  }

  getTokenInfo(){
    this.resetPasswordService.getTokenInfo(this.token).subscribe(
      result => {
        if(result.Success){
          this.tokenIsValid = true;
          this.email = result.data;
        }
        else{
          this.tokenIsValid = false;
          this.commonFunctionsService.showResultNotification(result, true, () => {
            setTimeout(() => {
              this.router.navigate(['/login']);
            }, 500);
          });
        }
      }
    )
  }

  resetPassword() {
    this.isLoading = true;
    this.resetPasswordService.resetPassword(this.token, this.password)
      .subscribe(
        result => {
          this.isLoading = false;
          if(result.Success){
            this.commonFunctionsService.showNotification('success', 'Parolanız başarılı bir şekilde güncellenmiştir. Yeni parolanız ile giriş yapabilirsiniz.', true, '', () => {
              setTimeout(() => {
                this.router.navigate(['/login']);
              }, 500);
            })
          }
          else{
            this.tokenIsValid = false;
            this.commonFunctionsService.showResultNotification(result, true);
          }

        },
        (err) => {
          this.isLoading = false;
          this.commonFunctionsService.showNotification('error', 'Bir sorun ile karşılaşıldı. Lütfen daha sonra tekrar deneyiniz.', true, 'Hata');
        }
      )
  }


}
